import * as Yup from 'yup';
import { sharedSchema } from '../shared/sharedSchema';

export const schema = Yup.object().shape({
    registerEmail: Yup.string().email('Nieprawdiłowy e-mail').required('To pole jest wymagane'),
    password: Yup.string()
        .min(8, 'Hasło musi mieć co najmniej 8 znaków')
        .required('To pole jest wymagane'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Hasła muszą być takie same')
        .required('To pole jest wymagane'),
    acceptRegistrationTerms: Yup.boolean().oneOf([true], 'Musisz zaakceptować regulamin'),
    ...sharedSchema,
});
